<template>
  <div class="m-1">
    <b-row class="align-items-end">
      <b-col>
        <text-editor
          id="customer-note-editor"
          v-model="newNote"
          :placeholder="$t('customers.tabs.notes.placeholder')"
          variant="simple"
        />
        <div
          v-if="newNote"
          class="text-right"
        >
          <b-button
            variant="primary"
            :disabled="processing || !newNote"
            @click="addNote"
          >
            {{ $t('shared.btn.add') }}
          </b-button>
        </div>
      </b-col>
    </b-row>

    <div
      v-if="notes.length === 0 && !loading"
      class="alert alert-info p-1 mt-1 text-center"
    >
      {{ $t('customers.tabs.notes.no-notes') }}
    </div>

    <div
      v-for="note in notes"
      :key="note.id"
    >
      <b-card class="shadow-none note-bubble mb-1">
        <div v-html="note.note" />
        <div class="text-right font-italic mb-n1">
          <small class="text-muted ml-50 mr-1">
            <span v-if="authorName(note)">
              {{ authorName(note) }} /
            </span>
            {{ transformDatetimeToHumanReadablePretty(note.createdAt) }}
          </small>
          <b-button
            size="sm"
            variant="flat-danger"
            @click="deleteNote(note)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
        </div>
      </b-card>
    </div>

    <div
      ref="infiniteScrollTrigger"
      class="mt-3"
    />

    <div
      v-if="loading"
      class="text-center my-1 mt-3"
    >
      <b-spinner small />
    </div>
  </div>
</template>

<script>
import TextEditor from '@/views/_global/TextEditor'
import useCustomerViewNotesTab from './useCustomerViewNotesTab'

export default {
  components: {
    TextEditor,
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  setup: useCustomerViewNotesTab,
}
</script>

<style lang="scss" scoped>
.note-bubble {
  background-color: #F5F5FA;

  .dark-layout & {
    background-color: #161D31;
  }
}
</style>
